import { Spaces } from './theme.types';

export const spaces: Spaces = {
  space1: '4px',
  space2: '8px',
  space3: '12px',
  space4: '16px',
  space5: '24px',
  space6: '32px',
  space7: '48px',
  space8: '64px',
  space9: '80px',
  space10: '96px',
};
